import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEditGuideToggleStatus } from "../../../redux/slices/statistics/statisticSlice";

function EditGuideToggle() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.statistics.EditGuideStatsToggleStatus);

  return (
    <div className="flex items-center justify-center w-full mt-8 mb-6">
      <label htmlFor="toggleB" className="flex items-center cursor-pointer">
        <div className="relative">
          <input id="toggleB" className="sr-only" />
            <div className="block bg-cyan-100 w-60 h-10 rounded-full">
              <div className="flex flex-row justify-evenly pt-3">
                <p
                  onClick={() => dispatch(setEditGuideToggleStatus("Info"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat"
                >
                 Info
                </p>
                <p
                  onClick={() => dispatch(setEditGuideToggleStatus("Step Flow"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat"
                >
                 Step Flow
                </p>
              
              </div>
            </div>
              {Status === "Info" ? (
                <div className="absolute left-6 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Info
                </div>
              ) : null}
              {Status === "Step Flow" ? (
                <div className="absolute left-32 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Step Flow
                </div>
              ) : null}
             
        </div>
      </label>
    </div>
  );
}

export default EditGuideToggle;
